import { render, staticRenderFns } from "./bsmeterdataitem.vue?vue&type=template&id=9aed9aa8&"
import script from "./bsmeterdataitem.vue?vue&type=script&lang=js&"
export * from "./bsmeterdataitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports